<template>
  <div style="width:80px;">
    <div>{{name}}&nbsp;</div>
    <vue-slider
      class="mb-4"
      v-model="value"
      tooltip="false"
      direction="vertical"
      height="100px"
      width="10"
      :min="min"
      :max="max"
      :interval="0.01"
      @drag="$emit('drag')"
    ></vue-slider>
  </div>
</template>
<script>
import vueSlider from "vue-slider-component";

export default {
  name: "Slider",
  props: ["name", "min", "max", "allSlidersValues", "index"],
  components: {
    vueSlider
  },
  data() {
    return {};
  },
  computed: {
    value: {
      get() {
        return this.allSlidersValues.length == 0
          ? this.min + (this.max - this.min) / 2
          : this.allSlidersValues[parseInt(this.index)];
      },
      set: function(v) {
        this.allSlidersValues[parseInt(this.index)] = v;
      }
    }
  }
};
</script>